import React from "react";
import { Link } from "react-router-dom";
import { formatDate, getCategoryLabel, stripHtml } from "./resourcesHelpers";

/**
 * Featured hero article (mirrors donor Inspiration HeroPost).
 * Uses twentytwentysix layout and typography.
 */
export default function ResourcesFeaturedHero({ article }) {
  if (!article) return null;

  const categoryLabel = getCategoryLabel(article);
  const title = article.title || "";
  const excerpt =
    article.excerpt ||
    (article.bodyHtml ? stripHtml(article.bodyHtml).substring(0, 200) + "…" : "") ||
    (Array.isArray(article.body) ? article.body[0]?.substring(0, 200) + "…" : "");
  const byline = [article.author, formatDate(article.publishedAt)].filter(Boolean).join(" · ");
  const imageUrl = article.heroImage || "";

  return (
    <article className="twentytwentysix-content__section twentytwentysix-content__featured-hero">
      <Link
        to={`/twentytwentysix/resources/${article.slug}`}
        className="twentytwentysix-content__featured-hero-inner"
        aria-label={`Read featured: ${title}`}
      >
        {imageUrl && (
          <div className="twentytwentysix-content__featured-hero-image-wrap">
            <img
              src={imageUrl}
              alt={title}
              className="twentytwentysix-content__featured-hero-image"
            />
          </div>
        )}
        <div className="twentytwentysix-content__featured-hero-content">
          {categoryLabel && (
            <p className="twentytwentysix-content__eyebrow twentytwentysix-content__featured-hero-kicker">
              {categoryLabel}
            </p>
          )}
          <h2 className="twentytwentysix-content__title twentytwentysix-content__featured-hero-title">
            {title}
          </h2>
          {byline && (
            <p className="twentytwentysix-content__copy twentytwentysix-content__copy--muted twentytwentysix-content__featured-hero-byline">
              {byline}
            </p>
          )}
          {excerpt && (
            <p className="twentytwentysix-content__copy twentytwentysix-content__featured-hero-excerpt">
              {excerpt}
            </p>
          )}
          <span className="twentytwentysix-content__link twentytwentysix-content__featured-hero-cta">
            Read more →
          </span>
        </div>
      </Link>
    </article>
  );
}
